<template>
  <div class="tw-w-full tw-p-0">
    <div class="tw-p-2 tw-justify-between colapse-area colapse">
      <div class="tw-flex">
        <div class="tw-mr-4 tw-font-bold tw-text-lg">{{installmentNumber}}</div>
        <div class="tw-flex tw-flex-col">
           <span><strong>{{ $gettext("VALUE_INVOICE_DOCUMENT") }}</strong>: {{ value }}</span>
           <span><strong>{{ $gettext("MATURITY") }}</strong>: {{ dueDate }}</span>
           <span><strong>{{ $gettext("INTEREST_INSTALLMENT") }}</strong>: {{ interest }}</span>
        </div>
      </div>
      <div>
        <q-btn
          flat
          icon="mdi-arrow-collapse-vertical"
          class="tw-text-warmGray-100"
          @click="openCloseTable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'HeaderColapseTableNegotiation',
  props: {
    value: String,
    dueDate: String,
    interest: Number,
    installmentNumber: Number
  }
})
export default class HeaderColapseTableNegotiation extends Vue {
  openCloseTable () {
    this.$emit('colapse')
  }
}
</script>

<style lang="scss" scoped>
@import "tailwindcss/utilities";

.colapse-area {
  background-color: #5898aa;
  display: flex;

}

.colapse {
  color: #fff;
}

</style>
